import freemium from 'assets/images/dashboard/pricing/freemium.svg';
import premium from 'assets/images/dashboard/pricing/premium.svg';
import { PLAN_NAME, PLAN_TYPE } from 'helper/checkPlan.helper';
export const pricingPlanCardItems = [
    {
        id: '234999',
        heading: PLAN_TYPE.Freemium,
        haedingToShow: PLAN_NAME.Essentials,
        subTitle: `Get started with the two-way communication basics and start building better relationships with current or new investors.`,
        currency: ``,
        amount: 'Free',
        recurring: '',
        buttonName: 'Continue',
        textAfterButton: 'Features:',
        subDescription: `Up to 5000 shareholders. Forever.`,
        planId: '',
        updateListItem: {
            first: [
                {
                    id: '234999-1',
                    text: 'Question segmentation'
                },
                {
                    id: '234999-2',
                    text: 'Two-way communication workflow'
                },
                {
                    id: '234999-3',
                    text: 'Automated ASX announcement and share price integration'
                },
                {
                    id: '234999-4',
                    text: 'Receive text or voice investor questions'
                },
                {
                    id: '234999-5',
                    text: 'Investor engagement analytics'
                }
            ],
            second: [
                {
                    id: '234999-6',
                    text: 'Event creation'
                },
                {
                    id: '234999-7',
                    text: 'Custom announcements'
                },
                {
                    id: '234999-8',
                    text: '3 custom question templates'
                },
                {
                    id: '234999-9',
                    text: '2 team member limit'
                }
            ]
        },
        listItem: [
            {
                id: '234999-1',
                text: 'Question segmentation'
            },
            {
                id: '234999-2',
                text: 'Two-way communication workflow'
            },
            {
                id: '234999-3',
                text: 'Automated ASX announcement and share price integration'
            },
            {
                id: '234999-4',
                text: 'Receive text or voice investor questions'
            },
            {
                id: '234999-5',
                text: 'Investor engagement analytics'
            },
            {
                id: '234999-6',
                text: 'Event creation'
            },
            {
                id: '234999-7',
                text: 'Custom announcements'
            },
            {
                id: '234999-8',
                text: '3 custom question templates'
            },
            {
                id: '234999-9',
                text: '2 team member limit'
            }
        ],
        footerText: '',
        footerIcon: freemium
    },
    {
        id: '235000',
        heading: PLAN_TYPE.Premium,
        haedingToShow: PLAN_NAME.Premium,
        subTitle: `Scale two-way communication to attract and retain the right investors. Use advanced features to understand how to keep investors happy.`,
        currency: `A$`,
        amount: { 5000: '399', 20000: '1,299', 50000: '2,499', 100000: '4,299', infinite: 'Custom' },
        recurring: 'month',
        recurringYear: 'year',
        buttonName: 'Continue',
        subDescription: {
            5000: 'Up to 5000 shareholders, 95c per shareholder',
            20000: 'Up to 20,000 shareholders, 78c per shareholder',
            50000: 'Up to 50,000 shareholders, 60c per shareholder',
            100000: 'Up to 100,000 shareholders, 52c per shareholder',
            infinite: 'Please contact sales if you have over 100,000 shareholders'
        },
        planId: '',
        textAfterButton: 'Everything in Essential plus:',
        updateListItem: {
            first: [
                {
                    id: '235000-1',
                    text: 'Real time investor sentiment score'
                },
                {
                    id: '235000-2',
                    text: 'Event attachments and analytics'
                },
                {
                    id: '235000-3',
                    text: 'Unlimited question registry and response templates'
                },
                {
                    id: '235000-4',
                    text: 'Advanced drafting and approval workflow'
                },
                {
                    id: '235000-5',
                    text: 'Question category reports'
                }
            ],
            second: [
                {
                    id: '235000-6',
                    text: 'Investor profiling and segmentation'
                },
                {
                    id: '235000-7',
                    text: 'Assign questions to team members'
                },
                {
                    id: '235000-8',
                    text: 'Unlimited team members'
                },
                {
                    id: '235000-9',
                    text: 'Slack community invitation'
                }
            ]
        },
        listItem: [
            {
                id: '235000-1',
                text: 'Real time investor sentiment score'
            },
            {
                id: '235000-2',
                text: 'Event attachments and analytics'
            },
            {
                id: '235000-3',
                text: 'Unlimited question registry and response templates'
            },
            {
                id: '235000-4',
                text: 'Advanced drafting and approval workflow'
            },
            {
                id: '235000-5',
                text: 'Question category reports'
            },
            {
                id: '235000-6',
                text: 'Investor profiling and segmentation'
            },
            {
                id: '235000-7',
                text: 'Assign questions to team members'
            },
            {
                id: '235000-8',
                text: 'Unlimited team members'
            },
            {
                id: '235000-9',
                text: 'Slack community invitation'
            }
        ],
        footerText: '',
        footerIcon: premium
    },
    {
        id: '235001',
        type: 'shareholder',
        headingToShow: 'Find your plan',
        subTitle: 'How many shareholders does the company have?',
        textAfterButton: 'This will help us calculate the best plan for you.',
        updateHeadingToShow: 'Number of shareholders',
        menuListSelection: {
            default: {
                name: 'Up to 5000 shareholders',
                value: '5000'
            },
            lists: [
                {
                    id: '2009444',
                    name: 'Up to 5000 shareholders',
                    value: '5000'
                },
                {
                    id: '2009445',
                    name: 'Up to 20,000 shareholders',
                    value: '20000'
                },
                {
                    id: '2009446',
                    name: 'Up to 50,000 shareholders',
                    value: '50000'
                },
                {
                    id: '2009447',
                    name: 'Up to 100,000 shareholders',
                    value: '100000'
                },
                {
                    id: '2009448',
                    name: 'Above 100,000 shareholders',
                    value: 'infinite'
                }
            ]
        },
        faqs: {
            title: 'FAQs',
            subTitle: 'Can’t find the answer you’re looking for?',
            link: 'Get in touch.',
            linkDirection: 'https://www.diolog.com.au/book-a-demo',
            lists: [
                {
                    id: '29999011',
                    title: 'If my company has 10,000 shareholders will I be able to use the Essentials plan?',
                    description: `Only companies with up to 5000 shareholders are eligible for the Free plan. However if you have above 5000 shareholders, get in touch with our team and we can organise a trial period for you.`
                },
                {
                    id: '29999012',
                    title: 'How many company users can manage a Diolog company account?',
                    description: `The Essentials plan has a limit of three team members, whereas you can invite unlimited team members on the Premium plan.`
                },
                {
                    id: '29999013',
                    title: 'If I have more shareholders, do I get more features?',
                    description: `No matter the size of your company's shareholder base, the features you have access to will be solely based on the plan you choose.`
                },
                {
                    title: `Is Diolog free for investors?`,
                    id: '29999014',
                    description: `Yes, Diolog is a free mobile application for any investors, downloadable via the App Store and Google Play store.`
                },
                {
                    title: `How does billing work?`,
                    id: '29999015',
                    description: `Plans are purchased per company and your company will be billed monthly depending on what plan you choose.`
                },
                {
                    title: `Can I try the Premium plan for free?`,
                    description: `Yes, we offer a two week free trial with the Premium Plan. If you would like a personalised demo or want to learn more about Premium, book in a demo for your team!`,
                    id: '29999016'
                }
            ]
        }
    }
];

export const COMPONENT_TYPE = {
    UPDATE: 'Update',
    ADD: 'Add'
};
